import { render, staticRenderFns } from "./uplist.vue?vue&type=template&id=c727479c&scoped=true&"
import script from "./uplist.vue?vue&type=script&lang=js&"
export * from "./uplist.vue?vue&type=script&lang=js&"
import style0 from "./uplist.vue?vue&type=style&index=0&id=c727479c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c727479c",
  null
  
)

component.options.__file = "uplist.vue"
export default component.exports